(function() { module.exports = window["jQuery"]; }());


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 0
// module chunks = 4 5 6 7 10 11 12 14 15 16 17 18 19 20 21 22 23 25 26 27 28 29 30 31 32 33 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 79